import withStyles from '@material-ui/core/styles/withStyles';
import CustomSelect from "components/CustomSelect/CustomSelect";
import Danger from "components/Typography/Danger";
import { t } from 'i18next';
import PropTypes from "prop-types";
import { default as React } from 'react';
import { withTranslation } from 'react-i18next';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { question_types } from "redux/config";


const styles = {};

class Component extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            questionSchema: null,
            question: null,
            answer: null
        }
        this.initState()
    }
    initState = () => {
        const question = this.props.question
        const answer = this.props.answer
        let questionSchema = question_types.filter((item) => item.type === question.question.type)[0]
        const initAnswer = question.question.answertype === 'group' ? questionSchema.options[0].value : 14

        this.state = {
            questionSchema,
            question,
            answer: answer ? answer : {
                id: question.id,
                value: null
            }
        }

    }
    componentDidMount = () => {
        this.saveAnswerData(true)
    }
    saveAnswerData = (init = false) => {
        let { answer, question } = this.state;
        if (this.props.onChange) {
            this.props.onChange({
                isValid: this.isValid(), answer: {
                    id: question.id,
                    ...answer
                }
            }, init)
        }
    }
    setAnswerData = (value) => {
        let { answer, question } = this.state;
        answer.value = value
        this.setState({
            answer: answer,
            error: null
        }, () => {
            console.info(answer)
            this.saveAnswerData()
        })
    }
    isValid = () => {
        const { question, answer } = this.state
        if (question.required && (!answer || !answer.value)) {
            this.showError(t('This question is required'));
            return false
        }
        return true
    }
    showError = (message) => {
        this.setState({ error: <Danger>*{message}</Danger> })
    }
    render() {
        const { questionSchema, error, answer } = this.state
        const question = this.state.question.question

        return <div >
            {error}
            {
                question.answertype === 'group' && <CustomSelect
                    onChange={data => {
                        this.setAnswerData(data.value);
                    }}
                    placeholder={t('Select your Age')}
                    value={questionSchema.options.filter((item) => item.value === answer.value)[0]}
                    options={questionSchema.options}
                />
            }
            {
                question.answertype === 'individual' && <CustomSelect
                    onChange={data => {
                        this.setAnswerData(data.value);
                    }}
                    placeholder={t('Select your Age')}
                    value={{ label: answer.value, value: answer.value }}
                    options={Array(140).fill(0).map((item, key) => ({ label: key + 14, value: key + 14 }))}
                />
            }
        </div>;
    }
}
Component.propTypes = {
    question: PropTypes.object,
    answer: PropTypes.object,
    onChange: PropTypes.func
}
const mapStatsToProps = ({ user }) => ({ user });
export default connect(mapStatsToProps)(
    withTranslation()(withStyles(styles, { withTheme: true })(Component))
);